export const NEIGHBORHOOD_GEO = {
  'Acres Home':           [29.87, -95.47],
  'Airline':              [29.83, -95.37],
  'Astrodome Area':       [29.69, -95.40],
  'Atascocita':           [29.99, -95.17],
  'Bellaire':             [29.71, -95.46],
  'Blalock Market':       [29.77, -95.51],
  'Central Northwest':    [29.84, -95.44],
  'Chinatown':            [29.70, -95.50],
  'Cinco Ranch':          [29.74, -95.76],
  'CityCentre':           [29.77, -95.56],
  'Cypress':              [29.97, -95.65],
  'Deerbrook':            [30.0,  -95.26],
  'Downtown':             [29.76, -95.37],
  'EaDo':                 [29.74, -95.36],
  'East Aldine':          [29.87, -95.27],
  'Eastwood':             [29.73, -95.32],
  'Energy Corridor':      [29.76, -95.66],
  'First Ward':           [29.77, -95.38],
  'Fourth Ward':          [29.76, -95.40],
  'Galleria':             [29.74, -95.46],
  'Greater Fifth Ward':   [29.78, -95.33],
  'Greenspoint':          [29.95, -95.41],
  'Greenway':             [29.73, -95.43],
  'Gulfgate':             [29.68, -95.31],
  'Heights':              [29.80, -95.41],
  'Houston Gardens':      [29.88, -95.28],
  'Humble':               [30.02, -95.23],
  'Hyde Park':            [29.74, -95.39],
  'Independence Heights': [29.83, -95.42],
  'Jersey Village':       [29.88, -95.57],
  'Katy':                 [29.79, -95.82],
  'Kemah':                [29.54, -95.02],
  'Little York':          [29.85, -95.33],
  'Memorial Park':        [29.76, -95.43],
  'Mid West':             [29.73, -95.49],
  'Midtown':              [29.74, -95.38],
  'Montrose':             [29.74, -95.40],
  'Museum District':      [29.72, -95.39],
  'Northside':            [29.81, -95.37],
  'Northwest Houston':    [29.86, -95.52],
  'Oak Forest':           [29.82, -95.44],
  'Rice Village':         [29.72, -95.42],
  'River Oaks':           [29.75, -95.43],
  'Rosenberg':            [29.56, -95.81],
  'Second Ward':          [29.75, -95.34],
  'South Central':        [29.71, -95.38],
  'South Side':           [29.67, -95.37],
  'Southeast Houston':    [29.67, -95.28],
  'Spring':               [30.07, -95.42],
  'Stafford':             [29.62, -95.56],
  'Sugar Land':           [29.60, -95.63],
  'Summerwood':           [29.96, -95.17],
  'The Woodlands':        [30.17, -95.47],
  'Todd Mission':         [30.13, -95.87],
  'Tomball':              [30.09, -95.62],
  'University Place':     [29.72, -95.41],
  'Uptown':               [29.74, -95.46],
  'Washington':           [29.77, -95.39],
  'Webster':              [29.54, -95.12],
  'West University Place':[29.71, -95.43],
  'Westside':             [29.74, -95.58],
  'Willowbrook':          [29.91, -95.55],
};

export const GEO_LNG_MIN = -95.92;
export const GEO_LNG_MAX = -94.97;
export const GEO_LAT_MIN = 29.44;
export const GEO_LAT_MAX = 30.28;
